// extracted by mini-css-extract-plugin
module.exports = {"headline":"Headline-module--headline--2Wg7X"};